/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   08/11/2022
 */

import React from "react";
import { Stack } from "@mui/material";
import { UseFormReturnType } from "@mantine/form";
import { CalendarSettingsForm } from "./CalendarSettingsDialog";
import EmployeesFilterForm from "../components/EmployeesFilterForm";

export interface CalendarSettingsEmployeesProps {
	form: UseFormReturnType<CalendarSettingsForm>;
}

export default function CalendarSettingsEmployees({ form }: CalendarSettingsEmployeesProps) {

	return (
		<Stack>
			<EmployeesFilterForm
				filter={form.values.employeesFilter}
				setFilter={(filter) => form.setFieldValue("employeesFilter", filter)}
			/>
		</Stack>
	);

}